// @flow
import { pick, mapValues } from 'lodash'

const setSize = dim => (dim > 1 ? `${dim}px` : `${dim * 100}%`)

type Props = {
  width?: number | string,
  height?: number | string,
}

const sizeProperties = ['width', 'height']

const size = (props: Props) => {
  const sizeProps = pick(props, sizeProperties)

  return mapValues(
    sizeProps,
    value => (typeof value === 'number' ? setSize(value) : value),
  )
}

export default size



// WEBPACK FOOTER //
// ./src/style/props/size.js